import React, { useEffect, useState } from "react";
import { getAllData } from "../../../Utils/firebaseServices";
import { Link } from "react-router-dom";
import { Button, Table } from "react-bootstrap";
import LoadingCircular from "../../../loader/LoadingCircular";

function Report() {
  const [userPortalData, setuserPortalData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await getAllData("financeUserPortal", setuserPortalData);
      } catch (error) {
        console.error("Error fetching data", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return <LoadingCircular />;
  }

  return (
    <div style={{ width: "100%", overflowX: "auto" }}>
      <h1 className="hide">Employee Report</h1>

      <Table bordered>
        <thead>
          <tr>
            <th style={headerStyle}>Sr.n.</th>
            <th style={headerStyle}>Email</th>
            <th style={headerStyle}>password</th>
            <th style={headerStyle}>Name</th>
            <th style={headerStyle}>Mobile No</th>
            <th style={headerStyle}>Status</th>
          </tr>
        </thead>
        <tbody>
          {userPortalData.length === 0 ? (
            <tr>
              <td colSpan={10} style={{ textAlign: "center" }}>
                No data available
              </td>
            </tr>
          ) : (
            userPortalData.map((item, index) => (
              <tr key={index}>
                <td style={{ textAlign: "center" }}>{index + 1}</td>
                <td style={{ textAlign: "center" }}>{item.email || "N/A"}</td>
                <td style={{ textAlign: "center" }}>
                  {item.password || "N/A"}
                </td>
                <td style={{ textAlign: "center" }}>{item.name || "N/A"}</td>
                <td style={{ textAlign: "center" }}>{item.mobilno || "N/A"}</td>
                <td style={{ textAlign: "center", padding: "16px" }}>
                  <Link
                    to={`/employee-report/status/${item.id}`}
                    className="custom-link"
                  >
                    Check Status
                  </Link>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </div>
  );
}

const headerStyle = {
  backgroundColor: "black",
  color: "white",
  textAlign: "center",
};
export default Report;
